import { Card, Col, Row } from 'antd';
import * as React from 'react';

import styles from './CardPage.module.less';

export interface CardPageProps {
  children: React.ReactNode;
  title?: React.ReactNode;
  bordered?: boolean;
}

export function CardPage({ children, title, bordered = true }: CardPageProps) {
  const headStyle = bordered ? undefined : { border: 'none' };

  return (
    <Row className={styles.container} align="middle" justify="center">
      <Col xs={24} style={{ maxWidth: 400 }}>
        <Card title={title} bordered={bordered} headStyle={headStyle}>
          {children}
        </Card>
      </Col>
    </Row>
  );
}
